var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useReactFlow } from 'reactflow';
import getSchema, { CONTEXT_MENU_OPTIONS } from './schema';
import { Container, Option, Text } from './styles';
export var ContextMenu = function (_a) {
    var _b;
    var isOpen = _a.isOpen, position = _a.position, onCreateCustomLogic = _a.onCreateCustomLogic, onCopy = _a.onCopy, onPaste = _a.onPaste, _c = _a.groupIds, groupIds = _c === void 0 ? [] : _c, patchwork = _a.patchwork, openGroup = _a.openGroup;
    var actionSchema = useMemo(function () {
        var _a;
        return (_a = {},
            _a[CONTEXT_MENU_OPTIONS.COPY] = onCopy,
            _a[CONTEXT_MENU_OPTIONS.PASTE] = onPaste,
            _a[CONTEXT_MENU_OPTIONS.CUSTOM_LOGIC] = onCreateCustomLogic,
            _a);
    }, [onCopy, onCreateCustomLogic, onPaste]);
    var getNodes = useReactFlow().getNodes;
    if (!isOpen)
        return null;
    var selectedNodes = getNodes().filter(function (node) { return node.selected; });
    var checkSelectedIdsInGroups = function (selectedIds, groups) {
        if (openGroup) {
            return false;
        }
        else {
            for (var groupId in groups) {
                var group = groups[groupId];
                for (var _i = 0, _a = group.patches; _i < _a.length; _i++) {
                    var patch = _a[_i];
                    if (selectedIds.includes(patch.id)) {
                        return true;
                    }
                }
            }
            return false;
        }
    };
    var checkForCustomLogic = function (patches, selectedIds) {
        return patches === null || patches === void 0 ? void 0 : patches.some(function (patch) {
            return (selectedIds === null || selectedIds === void 0 ? void 0 : selectedIds.includes(patch === null || patch === void 0 ? void 0 : patch.id)) && (patch === null || patch === void 0 ? void 0 : patch.logic) === 'custom_logic';
        });
    };
    var disabled = __spreadArray(__spreadArray(__spreadArray([], (!(selectedNodes === null || selectedNodes === void 0 ? void 0 : selectedNodes.length) ? [CONTEXT_MENU_OPTIONS.COPY] : []), true), (selectedNodes.length ? [CONTEXT_MENU_OPTIONS.PASTE] : []), true), ((selectedNodes === null || selectedNodes === void 0 ? void 0 : selectedNodes.length) < 2 ? [CONTEXT_MENU_OPTIONS.CUSTOM_LOGIC] : []), true);
    return (_jsx(Container, __assign({}, position, { children: (_b = getSchema(actionSchema)) === null || _b === void 0 ? void 0 : _b.map(function (item) {
            var customLogicDisable = (item === null || item === void 0 ? void 0 : item.label) === 'Create Custom Logic' &&
                (checkSelectedIdsInGroups(groupIds, patchwork === null || patchwork === void 0 ? void 0 : patchwork.logicGroups) ||
                    checkForCustomLogic(patchwork === null || patchwork === void 0 ? void 0 : patchwork.patches, groupIds));
            var isDisabled = disabled === null || disabled === void 0 ? void 0 : disabled.includes(item.key);
            return (_jsx(_Fragment, { children: !customLogicDisable && (_jsx(Option, __assign({ disabled: isDisabled, onClick: !isDisabled ? function () { return item.action(selectedNodes); } : undefined }, { children: _jsx(Text, { children: item.label }) }), item.id)) }));
        }) })));
};
